import './style.sass';

import clsx from 'clsx';
import FullWrapper from 'core/FullWrapper';
import { sanitize } from 'isomorphic-dompurify';
import Image from 'next/image';

import { listSteps } from '~/components/features/cases/NextComponents/cases/moscow-exchange/constants';
import Steps from '~/components/features/cases/NextComponents/cases/moscow-exchange/steps';

type SolutionStepType = {
    icon: string;
    text: string;
};
type SolutionListType = {
    header: string;
    description: string;
    solutionSteps?: SolutionStepType[];
    sideText?: string;
};

type SolutionPropsType = {
    solutionsList: SolutionListType[];
    listSteps: { icon: string; text: string }[];
};
const Solution = ({ solutionsList }: SolutionPropsType) => {
    return (
        <div className="moscowExchange-solution">
            <FullWrapper isMargin={false} className="moscowExchange-solutionCase">
                {/* eslint-disable-next-line no-secrets/no-secrets */}
                <div className="moscowExchange-solutionWrapper">
                    <div className="moscowExchange-solutionInner">
                        <div className="moscowExchange-solutionLeft">
                            <div className="moscowExchange-solutionTitle">Решение</div>
                        </div>
                    </div>
                    <div className="moscowExchange-solutionInner">
                        <div className="moscowExchange-solutionLeft">
                            <div className="moscowExchange-solutionDescription">
                                Для каждого проекта сформировали команды. Работу по&nbsp;двум
                                ресурсам вели параллельно, разложив ее&nbsp;на&nbsp;этапы:
                            </div>
                            <Steps listSteps={listSteps}></Steps>
                            <div className="moscowExchange-solutionDescription">
                                Основная часть работы состоит в&nbsp;аналитике, технической
                                оптимизации сайтов, актуализации и&nbsp;расширению семантического
                                ядра, улучшения юзабилити и&nbsp;развитию ссылочного профиля.
                                По&nbsp;каждому направлению команда формирует гипотезы,
                                реализует&nbsp;их, потом анализируем результат и&nbsp;далее либо
                                тиражируем решение или тестируем новую гипотезу.
                            </div>
                        </div>
                        <div className="moscowExchange-solutionRight">
                            Приоритеты сайта Московской биржи&nbsp;&mdash; Главная страница,
                            Новости, Ход торгов, Срочный рынок и&nbsp;страницы с&nbsp;динамикой
                            соотношения валют. Для сайта Финуслуги&nbsp;&mdash; это разделы
                            Сбережения, Кредиты, Страхование, Рейтинг банков и&nbsp;блог.
                        </div>
                    </div>
                    {solutionsList.map(item => {
                        return (
                            <div key={item.header} className="moscowExchange-solutionParagraf">
                                <div
                                    className={clsx(
                                        'moscowExchange-solutionLeft',
                                        'solution-title'
                                    )}
                                >
                                    {item.header}
                                </div>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: sanitize(item.description),
                                    }}
                                    className={clsx('moscowExchange-solutionLeft', 'solution-desc')}
                                />
                                <div className="moscowExchange-solutionInner">
                                    <div className="moscowExchange-solutionLeft">
                                        {item.solutionSteps &&
                                            item.solutionSteps.map(step => {
                                                return (
                                                    <div key={step.icon} className="solution-step">
                                                        <Image
                                                            src={step.icon}
                                                            width={40}
                                                            height={40}
                                                            alt={step.icon}
                                                        />
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: sanitize(step.text),
                                                            }}
                                                        ></div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                    {item.sideText && (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: sanitize(item.sideText),
                                            }}
                                            className={clsx('moscowExchange-solutionRight')}
                                        ></div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </FullWrapper>
        </div>
    );
};

export default Solution;
